<div class="tour-step" (click)="$event.stopPropagation()">
    <div class="tour-step__container">
        <!-- Comentado temporariamente até que todas as GIFs sejam definitas definitivamente -->
        <!-- @if (step?.gif) {
            <div class="tour-step__gif">
                <img [src]="step.gif" alt="Gif tour">
            </div>
        } -->

        <div class="tour-step__header">
            <span class="tour-step__title">{{step.title}}</span>
            <ng-icon 
                name="heroXMark" 
                (click)="confirmAction(step.tourRef)"
            >
            </ng-icon>
        </div>

        @if (step.alert) {
            <div class="tour-step__alert">
                <span class="tour-step__title tour-step__title--md">{{step.alert.title}}</span>
                <p class="tour-step__txt" [innerHTML]="step.alert.content"></p>
            </div>
        }
    
        @if (step.content) {
            <div class="tour-step__content">
                <p class="tour-step__txt">{{step.content}}</p>
            </div>
        }
    
        <div class="tour-step__actions" [ngClass]="{'tour-step__actions--start': tourService.steps.length == 1}">
            @if (step.showProgress) {
                <span class="tour-step__progress-count">
                    {{ tourService.steps.indexOf(step) + 1 }} de {{ tourService.steps.length }}
                </span>
            }

            @if (tourService.steps.length > 1) {
                <div class="tour-step__paginator">
        
                    @if (tourService.hasPrev(step)) {
                        <!-- PREV -->
                        <button 
                            class="my-btn my-btn--inversed my-btn--sz-md" 
                            [ngClass]="{'my-btn--disabled': !tourService.hasPrev(step)}" 
                            [disabled]="!tourService.hasPrev(step)" 
                            (click)="tourService.prev()"
                        >
                        Voltar
                        </button>
                    }
                
                    <!-- NEXT -->
                    <button 
                        class="my-btn my-btn--filled my-btn--sz-md" 
                        (click)="!tourService.hasNext(step) && tourService.steps.length > 1 
                        ? confirmAction(step.tourRef) 
                        : tourService.next()"
                        [gaEvent]="step.gaEvent ?? ''"
                    >
                    {{ 
                        !tourService.hasNext(step) && tourService.steps.length > 1 
                        ? "Concluir" 
                        : "Próximo" 
                    }}
                    </button>
                </div>
            }
    
        </div>
    </div>
</div>